import { render, staticRenderFns } from "./SubjectInfo.vue?vue&type=template&id=725c8b01&scoped=true&"
import script from "./SubjectInfo.vue?vue&type=script&lang=js&"
export * from "./SubjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c8b01",
  null
  
)

export default component.exports